module.exports = __webpack_public_path__ + "static/media/privateEquity.3cd72bcd.svg";